import Swiper, {Scrollbar} from 'swiper';
const breakpoint = window.matchMedia('(min-width: 768px)');
let mySwiper;

const breakpointChecker = function () {
    if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
    } else if (breakpoint.matches === false) {
        return enableSwiper();
    }
};

const enableSwiper = function () {
    mySwiper = new Swiper('.info-blocks-scroll', {
        modules: [Scrollbar],
        slidesPerView: 'auto',
        scrollbar: {
            el: ".info-blocks-scrollbar",
            hide: false,
            draggable: true
        },
    });
};

breakpoint.addListener(breakpointChecker);

breakpointChecker();